import React, { useContext } from 'react';

import linearTransform from 'helpers/linearTransform';
import {
  ArtworkPositioner,
  EntityType,
  EntityTitle,
  Header,
  ContentWrapper,
} from 'components/Header/EntityHeader/EntityHeader.style';
import CustomListMetadata from './CustomListMetadata';
import CuratorBadge from './shared/CuratorBadge';
import formatDate from '../../helpers/formatDate';
import { EntityContext } from 'context/entityContext';
import Artwork from 'components/base/Artwork/Artwork';

interface IHeaderProps {
  isCurator: boolean;
  isSmallScreen: boolean;
  title: string;
  thumbnailUrl: string;
  lastUpdated: Date;
}

const CustomListHeader: React.FC<IHeaderProps> = (props) => {
  const {
    isCurator,
    isSmallScreen,
    title,
    lastUpdated,
    thumbnailUrl,
    children,
  } = props;

  const fontSize = linearTransform(title.length, isSmallScreen);
  const formattedDate = formatDate(lastUpdated, 'day-short');

  const ctx = useContext(EntityContext);
  const { entityIds, entityType } = ctx;

  return (
    <Header>
      <ArtworkPositioner>
        <Artwork
          key={`entity-artwork-${entityIds?.[0] || ''}`}
          entityId={entityIds?.[0]}
          entityType={entityType}
          title={title}
          src={thumbnailUrl}
          isVersion={false}
        />
      </ArtworkPositioner>

      <ContentWrapper data-pw="header-entity-metadata">
        <EntityType>List</EntityType>
        {isCurator && <CuratorBadge marginLeft={2}>Curator</CuratorBadge>}
        <EntityTitle fontSize={fontSize}>{title}</EntityTitle>
        <CustomListMetadata metadata={`Last updated: ${formattedDate}`} />
        {children}
      </ContentWrapper>
    </Header>
  );
};

export default CustomListHeader;
